export function jobs(state) {
  return state.jobs;
}

export function available(state) {
  return state.available;
}

